import coreExAudio from '../resources/coreEx_concat.mp3';
import coreExSchedule from '../resources/coreEx_schedule.json';
import legHoldAudio from '../resources/legHold_concat.mp3';
import legHoldSchedule from '../resources/legHold_schedule.json';
import quadStretchAudio from '../resources/quadStretch_concat.mp3';
import quadStretchSchedule from '../resources/quadStretch_schedule.json';
import calfAudio from '../resources/calf_concat.mp3';
import calfSchedule from '../resources/calf_schedule.json';

// Per-stretch concatenated mp3 plus its schedule of setActive/setRep/
// metadata commands (see generateStretchAudio.js), keyed the same way the
// stretch functions from stretches.js are.
const CONCAT_AUDIO = {
  coreEx: { audio: coreExAudio, ...coreExSchedule },
  legHold: { audio: legHoldAudio, ...legHoldSchedule },
  quadStretch: { audio: quadStretchAudio, ...quadStretchSchedule },
  calf: { audio: calfAudio, ...calfSchedule },
};

export { CONCAT_AUDIO };
